"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadowDown1 = '0px 4px 7px rgba(0, 0, 0, 0.14)';
exports.shadowTop1 = '0px -4px 7px rgba(0, 0, 0, 0.14)';
exports.shadowLeft1 = '-4px 0px 7px rgba(0, 0, 0, 0.14)';
exports.shadowRight1 = '4px 0px 7px rgba(0, 0, 0, 0.14)';
exports.shadowDown2 = '0px 6px 14px rgba(0, 0, 0, 0.12)';
exports.shadowTop2 = '0px -6px 14px rgba(0, 0, 0, 0.12)';
exports.shadowLeft2 = '-6px 0px 14px rgba(0, 0, 0, 0.12)';
exports.shadowRight2 = '6px 0px 14px rgba(0, 0, 0, 0.12)';
exports.shadowDown3 = '0px 10px 30px rgba(0, 0, 0, 0.12)';
exports.shadowTop3 = '0px -10px 30px rgba(0, 0, 0, 0.12)';
exports.shadowLeft3 = '-10px 0px 30px rgba(0, 0, 0, 0.12)';
exports.shadowRight3 = '10px 0px 30px rgba(0, 0, 0, 0.12)';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhZG93cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zaGFkb3dzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQWEsUUFBQSxXQUFXLEdBQUcsaUNBQWlDLENBQUM7QUFDaEQsUUFBQSxVQUFVLEdBQUcsa0NBQWtDLENBQUM7QUFDaEQsUUFBQSxXQUFXLEdBQUcsa0NBQWtDLENBQUM7QUFDakQsUUFBQSxZQUFZLEdBQUcsaUNBQWlDLENBQUM7QUFFakQsUUFBQSxXQUFXLEdBQUcsa0NBQWtDLENBQUM7QUFDakQsUUFBQSxVQUFVLEdBQUcsbUNBQW1DLENBQUM7QUFDakQsUUFBQSxXQUFXLEdBQUcsbUNBQW1DLENBQUM7QUFDbEQsUUFBQSxZQUFZLEdBQUcsa0NBQWtDLENBQUM7QUFFbEQsUUFBQSxXQUFXLEdBQUcsbUNBQW1DLENBQUM7QUFDbEQsUUFBQSxVQUFVLEdBQUcsb0NBQW9DLENBQUM7QUFDbEQsUUFBQSxXQUFXLEdBQUcsb0NBQW9DLENBQUM7QUFDbkQsUUFBQSxZQUFZLEdBQUcsbUNBQW1DLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/shadows.js
// module id = 51
// module chunks = 0